/* Vyhledavani pracovist na strance /reference: geolokace + mereni hledani (dataLayer) */

jQuery(function () {
	var form = $('.map-search');
	if (form.length === 0) {
		return;
	}

	// Priblizne stredy kraju. Slug odpovida statickym routam /reference/{slug}.
	var regions = {
		'stredocesky':     [49.9000, 14.8500],
		'jihocesky':       [49.0500, 14.4500],
		'plzensky':        [49.6500, 13.2000],
		'karlovarsky':     [50.1500, 12.7000],
		'ustecky':         [50.5500, 13.8500],
		'liberecky':       [50.7500, 15.0500],
		'kralovehradecky': [50.3000, 15.9000],
		'pardubicky':      [49.9000, 16.2000],
		'vysocina':        [49.4500, 15.6000],
		'jihomoravsky':    [49.0000, 16.8000],
		'olomoucky':       [49.7000, 17.2000],
		'zlinsky':         [49.2000, 17.7500],
		'moravskoslezsky': [49.8000, 18.1000],
		'bratislavsky':    [48.3500, 17.2000],
		'trnavsky':        [48.4000, 17.6000],
		'trenciansky':     [48.8500, 18.0500],
		'nitriansky':      [48.2000, 18.3000],
		'zilinsky':        [49.2000, 18.9500],
		'banskobystricky': [48.6000, 19.4000],
		'presovsky':       [49.0500, 21.2000],
		'kosicky':         [48.6500, 21.3000]
	};

	// Mesta maji v datech vlastni seznam oddeleny od kraje (Brno 79 zaznamu vs. Jihomoravsky 33),
	// proto je nabizime jen uzivatelum primo z mesta a okoli, jinak vedeme na kraj.
	var cities = {
		'praha':      [50.0755, 14.4378],
		'brno':       [49.1951, 16.6068],
		'bratislava': [48.1486, 17.1077]
	};
	var cityRadiusKm = 20;

	function pushEvent(data) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push(data);
	}

	// URL kraje bereme z odkazu v mape, aby sedela jazykova mutace (/reference vs /referencie)
	function regionUrl(slug) {
		return $('.map-wrap a[data-region="' + slug + '"]').first().attr('href');
	}

	function distanceKm(lat1, lng1, lat2, lng2) {
		var toRad = Math.PI / 180;
		var dLat = (lat2 - lat1) * toRad;
		var dLng = (lng2 - lng1) * toRad;
		var a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
			+ Math.cos(lat1 * toRad) * Math.cos(lat2 * toRad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
		return 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	}

	function nearest(points, lat, lng) {
		var best = {slug: null, km: Infinity};
		for (var slug in points) {
			var km = distanceKm(lat, lng, points[slug][0], points[slug][1]);
			if (km < best.km) {
				best = {slug: slug, km: km};
			}
		}
		return best;
	}

	function nearestRegion(lat, lng) {
		var city = nearest(cities, lat, lng);
		if (city.km <= cityRadiusKm) {
			return city.slug;
		}
		return nearest(regions, lat, lng).slug;
	}

	// --- mereni hledani ---
	var results = $('#seznam-referenci[data-search-term]');
	if (results.length > 0) {
		pushEvent({
			event: 'reference_search',
			search_term: results.attr('data-search-term'),
			search_category: results.data('search-category') || null,
			search_results: results.data('search-results') || 0
		});
	}

	// --- geolokace ---
	var geoButton = form.find('.map-search__geo');
	var geoError = form.find('.map-search__error');

	if (!navigator.geolocation) {
		geoButton.hide();
		return;
	}

	function geoFailed() {
		geoButton.prop('disabled', false).removeClass('btn-disabled');
		geoError.show();
	}

	geoButton.on('click', function () {
		geoError.hide();
		geoButton.prop('disabled', true).addClass('btn-disabled');

		navigator.geolocation.getCurrentPosition(function (position) {
			var slug = nearestRegion(position.coords.latitude, position.coords.longitude);
			var url = regionUrl(slug);
			if (!url) {
				geoFailed();
				return;
			}
			pushEvent({event: 'reference_geolocation', search_region: slug});
			window.location.href = url;
		}, geoFailed, {timeout: 10000, maximumAge: 300000});
	});
});
